<template>
  <form :action="action" method="POST" target="_blank">
    <input v-for="field in fields" :key="field.name" type="hidden" :name="field.name" :value="field.value" />
    <button type="submit">
      <slot></slot>
    </button>
  </form>
</template>

<script>
export default {
  data() {
    return {
      fields: [],
      sortBy: "",
      sortType: "asc",
    };
  },

  computed: {
    action() {
      const { userId } = this.$store.state;
      return `/index.php?r=google-sheets/create&user_id=${userId}&table=workers&sort_by=${this.sortBy}&sort_type=${this.sortType}`;
    },
  },

  methods: {
    update(params) {
      console.log("update google form", params);

      this.sortBy = params.sortBy;
      this.sortType = params.sortType;

      const fields = [];

      const { globalFilters } = params;
      const columnFilters = params.activeFilteredColumns;

      const appendFilters = (filters, filtersName) => {
        filters.forEach((item) => {
          const filterName = item.id.split("_")[0];

          if (item.type === "list" && item.id === "postCategorySpecialty") {
            const values = item.value.map((item) => item.id).join(",");
            fields.push({
              name: `${filtersName}[posts][search_type]`,
              value: item.searchType,
            });
            fields.push({
              name: `${filtersName}[posts][values]`,
              value: values,
            });
          } else if (item.type === "list") {
            if (item.id === "workerType") {
              fields.push({
                name: `${filtersName}[${filterName}][value]`,
                value: item.value[0].id,
              });
            } else {
              let values = item.value.map((item) => item.id);
              values = values.filter((v, i) => values.indexOf(v) === i).join(",");
              fields.push({
                name: `${filtersName}[${filterName}][search_type]`,
                value: item.searchType,
              });
              fields.push({
                name: `${filtersName}[${filterName}][values]`,
                value: values,
              });
            }
          } else if (item.type === "number" && item.searchType === "4") {
            fields.push({
              name: `${filtersName}[${filterName}][value]`,
              value: item.value.start,
            });
            fields.push({
              name: `${filtersName}[${filterName}][search_type]`,
              value: item.searchType,
            });
            fields.push({
              name: `${filtersName}[${filterName}][value_2]`,
              value: item.value.end,
            });
          } else if (item.type === "boolean") {
            if (item.value === "1")
              fields.push({
                name: `${filtersName}[${filterName}][value]`,
                value: item.value,
              });
          } else {
            fields.push({
              name: `${filtersName}[${filterName}][value]`,
              value: item.value,
            });
            fields.push({
              name: `${filtersName}[${filterName}][search_type]`,
              value: item.searchType,
            });
          }
        });
      };

      appendFilters(globalFilters, "filters");
      appendFilters(columnFilters, "col_filters");

      this.fields = fields;
    },
  },
};
</script>
